import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import {ref} from "vue";
import {Routes} from "@/router/routes";
import {useRoute, useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const drawer = ref(false);
const miniState = ref(true)

const menuList = ref([
  {
    title: "Products",
    icon: "inventory_2",
    name: "products",
    route: Routes.PRODUCTS
  },
  {
    title: "Sliders",
    icon: "slideshow",
    name: "sliders",
    route: Routes.SLIDERS
  },
  {
    title: "Specifications",
    name: "specifications",
    icon: "format_list_numbered",
    route: Routes.SPECIFICATIONS
  },
  {
    title: 'Gifts',
    name: 'gifts',
    icon: 'redeem',
    route: Routes.GIFTS
  },
  {
    title: 'Feature',
    name: 'feature',
    icon: 'star_rate',
    route: Routes.FEATURE
  },
  {
    title: 'Brands',
    name: 'brand',
    icon: 'copyright',
    route: Routes.BRAND
  },
  {
    title: 'Countries',
    name: 'countries',
    icon: 'location_on',
    route: Routes.COUNTRIES
  },
  {
    title: 'Categories',
    name: 'categories',
    icon: 'account_tree',
    route: Routes.CATEGORIES
  }
])

function push(route: string) {
  router.push(route)
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "lHh Lpr lff",
    container: "",
    class: "h-[100vh] bg-chrome-bg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, { class: "bg-mg-900" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value)),
                round: "",
                dense: "",
                icon: "menu"
              }),
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("mono")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
        "show-if-above": "",
        mini: miniState.value,
        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (miniState.value = false)),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (miniState.value = true)),
        "mini-to-overlay": "",
        width: 200,
        breakpoint: 600,
        class: "bg-green-950 text-white border-r-transparent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_scroll_area, {
            class: "fit border-r-0",
            "horizontal-thumb-style": { opacity: 0 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, { padding: "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (menu) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      active: _unref(route).name === menu.name,
                      "active-class": "text-teal-7",
                      onClick: ($event: any) => (push(menu.route)),
                      key: menu.route
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: menu.icon
                            }, null, 8, ["name"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menu.title), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["active", "onClick"])), [
                      [_directive_ripple]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "mini"]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_page, { padding: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})